import React, { useEffect, useRef, useState } from 'react';
import LoadingLogo from './LoadingLogo';
import { useTranslation } from 'react-i18next';

const PdfPreviewPopup = ({
  open,
  title = 'Aperçu PDF',
  onClose,
  getPdfBlob,
  filename = 'document.pdf',
}) => {
  const [loading, setLoading] = useState(false);
  const [pdfUrl, setPdfUrl] = useState(null);
  const createdUrlRef = useRef(null);
  const { t } = useTranslation();
  
  useEffect(() => {
    const cleanupUrl = () => {
      const current = createdUrlRef.current;
      if (current) {
        window.URL.revokeObjectURL(current);
        createdUrlRef.current = null;
      }
      setPdfUrl(null);
    };

    if (!open) {
      cleanupUrl();
      return cleanupUrl;
    }

    let active = true;
    const run = async () => {
      setLoading(true);
      try {
        const blob = await getPdfBlob?.();
        if (!active) return;
        if (!blob) return;
        const url = window.URL.createObjectURL(blob);
        createdUrlRef.current = url;
        setPdfUrl(url);
      } finally {
        if (active) setLoading(false);
      }
    };

    run();

    return () => {
      active = false;
      cleanupUrl();
    };
  }, [open, getPdfBlob]);

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-[1100] bg-black/50 flex items-center justify-center"
      onClick={() => onClose?.()}
    >
      <div
        className="bg-white rounded-[12px] shadow-[0px_20px_80px_#00000011] w-[92vw] h-[92vh] overflow-hidden flex flex-col"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="h-[56px] px-5 flex items-center justify-between border-b border-gray-100">
          <div className="text-[#043F87] font-semibold text-[16px] truncate pr-3">
            {title}
          </div>
          <div className="flex items-center gap-3">
            {pdfUrl && (
              <a
                href={pdfUrl}
                download={filename}
                className="px-4 py-2 rounded-[12px] bg-white border border-gray-200 text-primary font-semibold text-[12px] hover:bg-gray-50"
              >
                  {t('actions.download')}
                </a>
            )}
            <button
              type="button"
              onClick={() => onClose?.()}
              className="px-4 py-2 rounded-[12px] bg-[#043F87] text-white font-semibold text-[12px]"
            >
              {t('actions.close')}
            </button>
          </div>
        </div>

        <div className="flex-1 bg-[#F9FAFC]">
          {loading ? (
            <div className="h-full flex items-center justify-center">
              <LoadingLogo />
            </div>
          ) : pdfUrl ? (
            <iframe title="PDFPreview" src={pdfUrl} className="w-full h-full" />
          ) : (
            <div className="h-full flex items-center justify-center text-[#36495C]">
              Impossible de charger le PDF.
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PdfPreviewPopup;

